import { useContext } from 'react';
import UserManagerContext from './UserManagerContext';

const SilentRenew = () => {
  const { manager } = useContext(UserManagerContext);
  manager.signinSilentCallback();

  return null;
};

export default SilentRenew;
